/** Path: corporateCustomers/{uen} — doc id = normalizeUen(uen). */
import { collection, deleteDoc, doc, getDoc, getDocs, setDoc } from 'firebase/firestore';
import { db } from '../../../lib/firebase';
import type { CorporateCustomer } from '../../../types';
import type { CorporateCustomerRepository } from '../types';
import type { EntityId } from '../../../types/common';

const COLLECTION = 'corporateCustomers';

export const firestoreCorporateCustomerRepository: CorporateCustomerRepository = {
  async findById(id: EntityId): Promise<CorporateCustomer | null> {
    const snap = await getDoc(doc(db, COLLECTION, id));
    return snap.exists() ? (snap.data() as CorporateCustomer) : null;
  },

  async save(entity: CorporateCustomer): Promise<void> {
    await setDoc(doc(db, COLLECTION, entity.id), entity);
  },

  async delete(id: EntityId): Promise<void> {
    // Rules deny client deletes (admin included) — present only to satisfy
    // BaseRepository; a call will be rejected by /corporateCustomers rules.
    await deleteDoc(doc(db, COLLECTION, id));
  },

  async list(): Promise<CorporateCustomer[]> {
    const snap = await getDocs(collection(db, COLLECTION));
    return snap.docs.map((d) => d.data() as CorporateCustomer);
  },
};
